import script from "./PreviewButton.vue?vue&type=script&setup=true&lang=js"
export * from "./PreviewButton.vue?vue&type=script&setup=true&lang=js"

import "./PreviewButton.vue?vue&type=style&index=0&id=2445c6cb&lang=scss"

const __exports__ = script;

export default __exports__